import React from 'react';
import _ from 'lodash';
import { Dropdown } from '@atoms';

const customOnChange = (onChange, fieldNameId) => (value) => {
  onChange({
    target: {
      name: fieldNameId,
      value,
    },
  });
};

const dataToOptions = (data) =>
  _.map(data, ({ name, code }) => ({ value: code, label: name }));

const HOCLocalizationDropdown = ({ fieldId, fieldNameId, label }) => ({
  data = [],
  value,
  onChange,
  disabled,
  style,
}) => {
  if (data.length === 0) {
    disabled = true;
    value = '-';
  }

  return (
    <Dropdown
      id={fieldId}
      label={label}
      style={{ width: '100%' }}
      value={value}
      options={dataToOptions(data)}
      onChange={customOnChange(onChange, fieldNameId)}
      disabled={disabled}
      onClick={(event) => event.stopPropagation()}
    />
  );
};

const LanguageDropdown = HOCLocalizationDropdown({
  fieldId: 'languages-select',
  label: 'Primary consultation language',
  fieldNameId: 'language',
});

export { LanguageDropdown };



// WEBPACK FOOTER //
// ./components/molecules/LocalizationDropdown/LocalizationDropdown.js